import { useContext } from "react";
import { DTHoverDispatchContext } from "./DTHoverContext";

export function useDTHoverDispatchContext() {
  return useContext(DTHoverDispatchContext);
}
